import React from "react"
import InsightPage from '../../components/Insight/InsightPage';
import TopImage from '../../images/portillo_top_image.png';

export default function AnOpenLetterToPortillosArticle() {
  return (
    <InsightPage slugParam="an-open-letter-to-portillos-from-our-ceo"
      topImage={TopImage}
    />
  )};